export default {
  label: {
    edit: "Edit",
    link_campaign: "Check Campaign"
  }
};
